import axios from 'axios'
import { ElNotification, ElLoading, ElMessageBox } from 'element-plus'
import Cookies from 'js-cookie'
import { RequestOptions } from '../type/common'
import { local, redirect, apiHost } from '../utils/util'
import crypto from '../utils/crypto'
import store from '../store'
import { RootState } from '../type/store'
import { Base64 } from 'js-base64'
import website from '@/config/website'
import { removeToken } from '@/utils/auth'
import router from '@/router'

const createRequestOptions = (options: RequestOptions) => {
  const timestamp = new Date().valueOf()
  const sign = crypto.encrypt(timestamp, 'cnsgsmart-uat.sgs.net')
  const sgstoken = Cookies.get('sgsToken')
  const sgsLanguage = (store.state as unknown as RootState).common.language
  

  const headers = options.headers || {}
  //接收外部自定义header，但是不能覆盖默认的属性
  if (headers) {
    delete headers['Content-Type']
    delete headers.sign
    delete headers.timestamp
    delete headers.sgstoken
  }
  /* 定义系统来源 */
  const systemSourceList = [
    {
      keyword: 'sgs-pbm',
      source: 'Smart-Pbm',
    },
    {
      keyword: 'sgs-mart',
      source: 'SMART',
    },
  ]
  let systemSource = '' as string
  systemSourceList.forEach((item: { keyword: string; source: string }) => {
    if (options.url.indexOf(item.keyword) !== -1) {
      systemSource = item.source
    }
  })
  /* 为请求添加业务主体，例如prodct\metiral，从sesstion缓存获取 objectDetail值 */
  options.data = options.data || {}
  options.data.objectDetail = JSON.parse(sessionStorage.getItem('objectDetail') || '{}')
  let timezone = (0 - new Date().getTimezoneOffset()) / 60;
  // const originAlias = window.location.origin
  return {
    url: `${apiHost}${options.url}`,
    method: options.method,
    params: options.params,
    data: options.data,
    responseType: options.responseType,
    credentials: 'include', // 允许携带 Cookie
    headers: {
      'Content-Type': 'application/json',
      sign,
      timestamp,
      sgstoken,
      sgsLanguage,
      timezone,
      systemSource,
      ...headers,
    },
  }
}

// 定义加载状态
let loadingInstance: any = null
let count = 0
let hasShownTokenError = false

const showAuthExpiredAlert = () => {
  if (hasShownTokenError) return
  hasShownTokenError = true
  const isZh = (store.state as any)?.common?.language === 'zh-CN'
  const currentRoute = router.currentRoute.value
  ElMessageBox.alert(
    isZh ? '您的登录状态已超时或失效，请重新登录以继续操作。' : 'Your login status has timed out or is no longer valid. Please log in again to continue.',
    isZh ? '登录已超时' : 'Login Timeout',
    {
      confirmButtonText: isZh ? '重新登录' : 'Log in again',
      type: 'warning',
      showClose: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
    },
  ).then(() => {
    store.dispatch('LogOut')
    window.location.href = window.location.origin + '/web/login?redirect=' + encodeURIComponent(currentRoute.fullPath)
    window.location.reload()
  })
}

const showLoading = () => {
  if (!count) {
    loadingInstance = ElLoading.service({
      fullscreen: true,
      body: true,
      lock: true,
      text: 'loading...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    count++
  }
}

const hideLoading = () => {
  if (loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
  count = 0
}

// 创建 Axios 实例
const axiosInstance = axios.create()

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    //部分页面不需要每次请求都要loading
    if ('true' == config.headers.loading || config.headers.loading == true) {
      showLoading()
    }
    config.headers['Authorization'] = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`;
    return config
  },
  (error) => {
    hideLoading()
    return Promise.reject(error)
  },
)
// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    hideLoading()
    // 判断是否为文件流
    const fileStreamContentTypes = [
      'application/octet-stream',
      'application/vnd.ms-excel',
    ]
    const contentType = response.headers['content-type'];
    const resTypeIsBlob = response.config.responseType == 'blob';
    if (resTypeIsBlob || (
      contentType &&
      fileStreamContentTypes.some((type) => contentType.includes(type)))
    ) {
      return response // 直接返回响应，让调用者处理文件流
    }
    if ( response.data.code !== 401 && 
      (response.status == 200 &&
        !response.data.data &&
        (response.data.length >= 0 || Object.keys(response.data).length > 0)) ||
      response.data.code === 200 ||
      response.data.status === 200
    ) {
      return response.data
    } else if (response.status === 401 || response.data.code === 401) {
      showAuthExpiredAlert()
      return response.data
    } else if (response.status === 204) {
      
    } else {
      console.log('提示错误了？？？？', response)
      ElNotification.error(response.data.message || response.data.msg)
      return response.data
    }
  },
  (error) => {
    console.log('异常了', error)
    hideLoading()
    if (error.response && error.response.status === 401) {
      showAuthExpiredAlert()
    } else if (error.response && error.response.status === 400) {
      ElNotification.error('非法输入拦截')
      if(!Cookies.get('sgsToken')){
        showAuthExpiredAlert()
      }
      return {
        resultCode: error.response.data.status,
        resultMsg: error.response.data.message,
      }
    } else {
      if(!Cookies.get('sgsToken')){
        showAuthExpiredAlert()
      }
      ElNotification.error(error.message || '网络异常，请稍后重试')
      return Promise.reject(error)
    }
  },
)

// 定义请求函数
const request = async (options: RequestOptions) => {
  return axiosInstance({
    ...createRequestOptions(options),
  })
}

export default request
